import { useQuery } from '@tanstack/react-query';
import { getProductOfferByID } from '../api/client';

export const useProductOffer = (id: string) => {
     const fetchProductOffer = useQuery({
        queryKey: ['productOffer', id],
        queryFn: () => getProductOfferByID(id),
        enabled: !!id,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    });

    return fetchProductOffer;
};